const sunsetMadnessHomepageEditorConfig = {
 initialContent: {
  hero_title: "",
  hero_subtitle: "",
  hero_button_label: "REGISTER",
  hero_button_link: "",

  logo_image_url: "",
  hero_background_image_url: "",
 },

 imageFields: {
  hero: {
   contentKey: "logo_image_url",
  },

  secondHero: {
   contentKey: "hero_background_image_url",
  },
 },

 loadContent(content = {}) {
  return {
   ...this.initialContent,
   ...content,
  };
 },

 buildContent(templateState = {}, sharedState = {}) {
  return {
   hero_title:
    templateState.hero_title?.trim() || "",

   hero_subtitle:
    templateState.hero_subtitle?.trim() || "",

   hero_button_label:
    templateState.hero_button_label?.trim() || "REGISTER",

   hero_button_link:
    templateState.hero_button_link?.trim() || "",

   logo_image_url:
    sharedState.resolvedImageUrls?.hero || "",

   hero_background_image_url:
    sharedState.resolvedImageUrls?.secondHero || "",
  };
 },

 getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,
 }) {
  const hero = getImageField("hero");
  const secondHero = getImageField("secondHero");

  return {
   templateState,
   setTemplateField,

   heroImageFile: hero.file,
   setHeroImageFile: (file) =>
    setImageFile("hero", file),

   existingHeroImageUrl: hero.existingUrl,

   removeHeroImage: hero.remove,
   setRemoveHeroImage: (remove) =>
    setImageRemoved("hero", remove),

   secondHeroImageFile: secondHero.file,
   setSecondHeroImageFile: (file) =>
    setImageFile("secondHero", file),

   existingSecondHeroImageUrl:
    secondHero.existingUrl,

   removeSecondHeroImage: secondHero.remove,
   setRemoveSecondHeroImage: (remove) =>
    setImageRemoved("secondHero", remove),
  };
 },
};

export default sunsetMadnessHomepageEditorConfig;